import React, { useRef, useState } from "react";
import { Box, Typography } from "@mui/material";
import { motion, useAnimation } from "framer-motion";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import DoubleArrow from "../../assets/double.png"
import { useNavigate, useParams } from "react-router-dom";
import logger from "../../Utils/logger";

const HANDLE_WIDTH = 60;
const HANDLE_OFFSET = 5;

export default function SwipeToVend({fetchCode}) {
  const navigate=useNavigate()
  const [swiped, setSwiped] = useState(false);
  const [completed, setCompleted] = useState(false);
  const controls = useAnimation();
  const trackRef = useRef(null);

  const {orderId}=useParams()
  const handleSwipe = async () => {
    setSwiped(true);
    setCompleted(true); // change icon -> image
    logger.log("✅ Swipe action triggered!");
    fetchCode()
    //navigate(`/vendOrder/number/${orderId}`)
      setTimeout(() => {
    controls.start({ x: 0 });
  }, 1000);

  }

  // Max drag distance = track width minus handle, so it works on any screen size
  const getMaxDrag = () => {
    const trackWidth = trackRef.current ? trackRef.current.offsetWidth : 300;
    return trackWidth - HANDLE_WIDTH - HANDLE_OFFSET * 2;
  };

  return (
    <Box
      sx={{
        position: "fixed",
        left: 0,
        right: 0,
        bottom: "calc(20px + env(safe-area-inset-bottom))",
        display: "flex",
        justifyContent: "center",
        px: 2,
        zIndex: 998,
        pointerEvents: "none",
      }}
    >
      <Box
        ref={trackRef}
        sx={{
          position: "relative",
          width: "100%",
          maxWidth: 560,
          height: 60,
          borderRadius: "12px",
          backgroundColor: "rgba(0, 177, 118, 1)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
          boxShadow: "0px 4px 12px rgba(0,0,0,0.2)",
          pointerEvents: "auto",
        }}
      >
        <Typography
          variant="h6"
          sx={{ color: "white", fontWeight: 600, zIndex: 1, fontSize: { xs: "1.1rem", sm: "1.25rem" } }}
        >
          Swipe To Vend
        </Typography>

        {/* Swiper Handle */}
        <motion.div
          drag="x"
          dragConstraints={trackRef}
          dragElastic={0}
          dragMomentum={false}
          animate={controls}
          onDragEnd={(e, info) => {
            if (info.offset.x > 0.9 * getMaxDrag()) {
              // 90% threshold
              handleSwipe();
            } else {
              controls.start({ x: 0 });
            }
          }}
          style={{
            position: "absolute",
            left: HANDLE_OFFSET,
            width: HANDLE_WIDTH,
            height: "90%",
            background: "#fff",
            borderRadius: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "grab",
            zIndex: 2,
            touchAction: "none",
          }}
        >
          {DoubleArrow ? (
            <img
              src={DoubleArrow} // <-- replace with your image path
              alt="done"
              style={{ width: 28, height: 28 }}
              draggable={false}
            />
          ) : (
            <ArrowForwardIosIcon sx={{ color: "#00A86B", fontSize: 28 }} />
          )}
        </motion.div>
      </Box>
    </Box>
  );
}
